import(/* webpackMode: "eager" */ "/vercel/path0/apps/magicsky/src/app/not-found.tsx");
